export const module = {
  info: {
    name: 'voip-vendor-destination-status',
    caption: 'voip vendor destination status'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
